module.exports = __webpack_public_path__ + "media/images/emblems/Steg-Hohtenn-Coat_of_Arms-d4e2c9e3534b8078f65de8d844491bb1.png";